export default {
  dbl_create_dashboard_search: "搜索",
  dbl_create_dashboard_tab: "选项卡",
  dbl_create_dashboard_text: "文本",
  dbl_create_dashboard_text_placeholder: "请输入内容...",
  dbl_create_dashboard_text_background_color: "背景颜色",
  dbl_create_dashboard_filter: "筛选器",
  dbl_create_dashboard_filter_type: "筛选器类型",
  dbl_create_dashboard_filter_type_placeholder: "请选择筛选器类型",
  dbl_create_dashboard_default_type: "默认类型",
  dbl_create_dashboard_default_type_placeholder: "请选择默认类型",
  dbl_create_dashboard_default_value: "默认值",
  dbl_create_dashboard_default_value_placeholder: "请选择",
  dbl_create_dashboard_filter_name: "筛选器名称",
  dbl_create_dashboard_filter_name_placeholder: "输入筛选器名称",
  dbl_create_dashboard_filter_name_length_error: "长度不超过10字符",
  dbl_create_dashboard_dataset: "数据集",
  dbl_create_dashboard_dataset_placeholder: "请选择数据集",
  dbl_create_dashboard_column: "字段",
  dbl_create_dashboard_column_placeholder: "请选择字段",
  dbl_create_dashboard_input: "右侧输入",
  dbl_create_dashboard_date: "日期",
  dbl_create_dashboard_string: "字符串",
  dbl_create_dashboard_value: "值",
  dbl_create_dashboard_country: "国家",
  dbl_create_dashboard_option_value: "选项值",
  dbl_create_dashboard_scope: "生效范围",
  dbl_create_dashboard_scope_show: "显示范围",
  dbl_create_dashboard_scope_setting: "范围设置",
  dbl_create_dashboard_user_filter_info: '用户筛选器仅对已关联用户属性的图表生效，当前支持的图形包括：表格、折线图、柱状图和纯数字卡片。',
  dbl_create_dashboard_user_filter_scope_setting_info: '当前支持的图形包括：表格、折线图、柱状图和纯数字卡片。',
  // dbl_create_dashboard_scope_info: "过滤器将自动与存在查询字段的图表关联，图表的其余部分可以指定关联字段。",
  dbl_create_dashboard_scope_same: "应用于相同数据集",
  dbl_create_dashboard_scope_same_info: "所有使用这个数据集的图表都会受到这个筛选器的影响",
  dbl_create_dashboard_scope_specific: "应用于特定图表",
  dbl_create_dashboard_scope_specific_info: "只有选中的图表会受到这个筛选器的影响",
  dbl_create_dashboard_scope_join_placeholder: "连接字段",
  dbl_create_dashboard_scope_join_error: "连接字段类型不匹配",
  dbl_create_dashboard_scope_join_empty: "不能为空",
  dbl_create_dashboard_filter_option_desc: "原维度值",
  dbl_create_dashboard_filter_dataset_desc: "同数据表",

  dbl_create_dashboard_svae_dashboard: "保存报表",
  dbl_create_dashboard_svae_template: "保存模板",

  dbl_create_dashboard_dashboard_name: "报表名称",
  dbl_create_dashboard_dashboard_placeholder: "请输入报表名称",
  dbl_create_dashboard_dashboard_same: "已存在同名报表，请重新输入",
  dbl_create_dashboard_name_length_error: "长度不超过50字符",

  dbl_create_dashboard_blank_title: "您可以将组件和图表拖放到报表设计面板。",
  dbl_create_dashboard_blank_des: "支持创建新图表或使用右侧面板中的现有图表。",
  dbl_create_dashboard_un_named: "未命名报表",
  dbl_create_dashboard_layout_elements: "布局",
  dbl_create_dashboard_chart: "图表",
  // 等产品提供中英文
  dbl_create_dashboard_sort_by_time_desc: "时间倒序",
  dbl_create_dashboard_sort_by_time_asc: "时间正序",
  dbl_create_dashboard_leave_title: "保存报表？",
  dbl_create_dashboard_leave_des: "当前页面尚未保存，如离开将会丢失所有内容。",
  dbl_create_dashboard_check_date_fail: "无法转换为日期类型",
  dbl_create_dashboard_check_date: "校验日期类型",
	
  dbl_create_dashboard_add_filter: "添加筛选器",
  dbl_create_dashboard_delete_filter_title: "是否确认删除筛选器？",
  dbl_create_dashboard_delete_filter_content: "删除操作无法撤消，请谨慎操作。",
	
  dbl_create_dashboard_applied: "应用筛选器（{count}）",
  
  dbl_create_dashboard_dataset_search_placeholder: "可以通过搜索得到更多数据表。",
  // dbl_create_dashboard_dataset_search_bottom_tip: "可以通过搜索得到更多数据表",
  dbl_create_dashboard_dataset_detail_name: '名称',
  dbl_create_dashboard_dataset_detail_database_type: '数据库类型',
  dbl_create_dashboard_dataset_detail_database_name: '数据库名称',
  dbl_create_dashboard_dataset_detail_schema: 'Schema',
  dbl_create_dashboard_dataset_detail_description: '表描述',
  
  dbl_create_dashboard_same_dataset: '相同数据表',
  dbl_create_dashboard_related_dataset: '相关数据表',
  dbl_create_dashboard_other_dataset: '其它数据表',
  
  dbl_create_dashboard_data_source: '数据源',
  
  dbl_create_dashboard_icon_explore: '探索',
  dbl_create_dashboard_explore_tip: '新功能：探索功能，点击这里进行探索！',
  
  dbl_create_dashboard_tab_rename: '重命名',
  dbl_create_dashboard_tab_delete: '删除',
  dbl_create_dashboard_tab_add: '添加选项卡',
  dbl_create_dashboard_tab_duplicate_name: '重复命名',
  dbl_create_dashboard_tab_delete_title: '删除报表选项卡?',
  dbl_create_dashboard_tab_delete_desc: '删除 {name}？删除选项卡将删除选项卡里面的全部内容。',
  
  dbl_create_dashboard_default_date: '默认日期：最后一个日期值',
  dbl_create_dashboard_default_date_info: '进入报表页面，卡片默认展示最后一个日期数据，调整筛选日期后，按实际日期展示聚合数据',
  
  dbl_create_dashboard_depend: '依赖于',
  dbl_create_dashboard_relevant_config_title: '关联筛选器配置',
  dbl_create_dashboard_relevant_config_info: '支持将同一数据表中的其它字符串筛选器配置为当前筛选器的关联筛选器，仅显示相关值。',
  dbl_create_dashboard_relevant_config_add: '添加子筛选器',
  dbl_create_dashboard_relevant_has_add_info: '{filterName}已添加至子筛选器',
  dbl_create_dashboard_relevant_has_parent: '{filterName}已被配置为父筛选器',
  
  dbl_create_dashboard_show_contact: '显示联系人',
  dbl_create_dashboard_basic_components: '基础组件',
  dbl_create_dashboard_show_contact_info: '报表将展示最近更新人的信息',
  dbl_create_dashboard_contact_error: '获取联系人失败',
  
  dbl_dashboard_contact_prefix: '如果您有任何疑问，请联系创建者 ',
  
  dbl_create_dashboard_show_only_my_charts: '仅显示我的图表',
  
  dbl_create_dashboard_disabled_default_date: '已设置对比时间，无法同时使用此功能',
};